var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"max-w-5xl mx-auto"},[_c('Projects',{attrs:{"product-id":_vm.basicProductId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }